import * as React from "react";
import type { SVGProps } from "react";
const SvgBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M1.75 15.75v43.5h60.5v-43.5H1.75ZM1.415 14C.633 14 0 14.633 0 15.415v44.17C0 60.367.633 61 1.415 61h61.17c.782 0 1.415-.633 1.415-1.415v-44.17c0-.782-.633-1.415-1.415-1.415H1.415Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M33 41.5a1.5 1.5 0 0 1 1.5-1.5h20a1.5 1.5 0 0 1 0 3h-20a1.5 1.5 0 0 1-1.5-1.5ZM33 46.5a1.5 1.5 0 0 1 1.5-1.5h20a1.5 1.5 0 0 1 0 3h-20a1.5 1.5 0 0 1-1.5-1.5ZM33 31.5a1.5 1.5 0 0 1 1.5-1.5h20a1.5 1.5 0 0 1 0 3h-20a1.5 1.5 0 0 1-1.5-1.5ZM33 36.5a1.5 1.5 0 0 1 1.5-1.5h20a1.5 1.5 0 0 1 0 3h-20a1.5 1.5 0 0 1-1.5-1.5ZM7 28.943c0-.52.422-.943.943-.943h20.114c.52 0 .943.422.943.943v21.114c0 .52-.422.943-.943.943H7.943A.943.943 0 0 1 7 50.057V28.943Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M8.75 29.75v19.5h18.5v-19.5H8.75ZM7.943 28a.943.943 0 0 0-.943.943v21.114c0 .52.422.943.943.943h20.114c.52 0 .943-.422.943-.943V28.943a.943.943 0 0 0-.943-.943H7.943Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M27 3a5 5 0 0 0-5 5v14h19V8a5 5 0 0 0-5-5h-9Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M27 4.75A3.25 3.25 0 0 0 23.75 8v12.25h15.5V8A3.25 3.25 0 0 0 36 4.75h-9ZM22 8a5 5 0 0 1 5-5h9a5 5 0 0 1 5 5v14H22V8Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M24 45.5H13v-1a5 5 0 0 1 5-5h1a5 5 0 0 1 5 5v1Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M12.125 44.5A5.875 5.875 0 0 1 18 38.625h1a5.875 5.875 0 0 1 5.875 5.875v1a.875.875 0 0 1-.875.875H13a.875.875 0 0 1-.875-.875v-1ZM18 40.375a4.125 4.125 0 0 0-4.125 4.125v.125h9.25V44.5A4.125 4.125 0 0 0 19 40.375h-1Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M23 36.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M18.5 39.25a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Zm0 1.75a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBadge;
